export default __webpack_public_path__ + "static/media/ic_shopping_cart_black_24px.e091067d.svg";